import React from 'react';
import { Box, IBoxProps } from '@styleseat/ui';

export type CircleProps = Omit<IBoxProps, 'minWidth' | 'minHeight' | 'maxWidth' | 'maxHeight' | 'paddingTop' | 'paddingBottom' | 'paddingLeft' | 'paddingRight' | 'paddingX' | 'paddingY' | 'padding'> & {
  diameter: number;
  applyShadowFilter?: boolean;
};

const shadowFilter = {
  filter: 'drop-shadow(0px 0px 4px rgba(18, 17, 17, 0.15))',
};

export const Circle: React.FC<CircleProps> = ({
  diameter,
  children,
  applyShadowFilter = null,
  ...restProps
}) => (
  <Box
    borderStyle="solid"
    {...restProps}
    style={applyShadowFilter ? shadowFilter : undefined}
    width={diameter}
    height={diameter}
    borderRadius={diameter}
    justifyContent="center"
    alignItems="center"
  >
    {children}
  </Box>
);
